import {
  IonBadge,
  IonButton,
  IonButtons,
  IonContent,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonNote,
} from "@ionic/react";
import React, { useState } from "react";
import Spacer from "../../../../components/spacer";

const CalendarKey: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <>
      <Spacer size="0" />
      <IonModal
        isOpen={showModal}
        onDidDismiss={() => setShowModal(false)}
        cssClass="my-custom-class"
      >
        <IonContent className="ion-padding">
          <h3>Calendar key</h3>
          <IonList>
            <IonItem lines="none">
              <IonBadge slot="start" color="danger">
                1
              </IonBadge>
              <IonLabel>Overdue</IonLabel>
            </IonItem>
            <IonItem lines="none">
              <IonBadge slot="start" color="warning">
                1
              </IonBadge>
              <IonLabel>Incomplete</IonLabel>
            </IonItem>
            <IonItem lines="none">
              <IonBadge slot="start" color="secondary">
                1
              </IonBadge>
              <IonLabel>Upcoming</IonLabel>
            </IonItem>
            <IonItem lines="none">
              <IonBadge slot="start" color="success">
                1
              </IonBadge>
              <IonLabel>Complete</IonLabel>
            </IonItem>
          </IonList>
        </IonContent>
        <IonButton onClick={() => setShowModal(false)}>Close</IonButton>
      </IonModal>
      <IonButtons className="calendarKeyButton">
        <IonButton onClick={() => setShowModal(true)} className="linked">
          View Calendar Key
        </IonButton>
      </IonButtons>
    </>
  );
};

export default CalendarKey;
